import {
  AUDIENCES_CREATE_FIELDS,
  AUDIENCES_DELETE_FIELDS,
  AUDIENCES_UPDATE_FIELDS,
  AUDIENCES_WRAPPER_FIELDS,
} from "Constants/audiences";

import { NotixApi } from "Services/api";
import { FetchRequest } from "./fetchRequest";

function prepareAudiencesToClient(response) {
  return {
    [AUDIENCES_WRAPPER_FIELDS.AUDIENCES_LIST]: response,
  };
}

function prepareAudienceToServer(data) {
  return {
    [AUDIENCES_CREATE_FIELDS.TITLE]: data.title,
    [AUDIENCES_CREATE_FIELDS.LABEL]: data.label,
    [AUDIENCES_CREATE_FIELDS.EDITABLE]: data.editable,
    [AUDIENCES_CREATE_FIELDS.ZONE_ID]: data.zone_id,
  };
}

function prepareAudienceDeleteToServer(id) {
  return {
    [AUDIENCES_DELETE_FIELDS.ID]: id,
  };
}

function prepareAudienceUpdateToServer(data) {
  return {
    [AUDIENCES_UPDATE_FIELDS.ID]: data.audienceId,
    [AUDIENCES_UPDATE_FIELDS.TITLE]: data.title,
    [AUDIENCES_UPDATE_FIELDS.LABEL]: data.label,
    [AUDIENCES_UPDATE_FIELDS.EDITABLE]: data.editable,
    [AUDIENCES_UPDATE_FIELDS.ZONE_ID]: data.zone_id,
  };
}

class Audiences {
  async load(query) {
    const result = await FetchRequest({
      url: `/ssp/audiences${query ? query : ""}`,
      method: "GET",
      useToken: true,
    });
    return prepareAudiencesToClient(result);
  }

  async getCount() {
    return await FetchRequest({
      url: `/ssp/counter/audience-subscribers`,
      method: "GET",
      useToken: true,
    });
  }

  create(data) {
    return NotixApi.post(
      `/audiences/create`,
      prepareAudienceToServer(data)
    );
  }

  delete(id) {
    return NotixApi.post(
      `/audiences/delete`,
      prepareAudienceDeleteToServer(id)
    );
  }

  update(data) {
    return NotixApi.post(
      `/audiences/update`,
      prepareAudienceUpdateToServer(data)
    );
  }
}

const audiencesInstance = new Audiences();

export default audiencesInstance;